export const gssDatasets = [
  { id: "obj", name: "obj", title: "Objectifs", label: "Objectifs", path: "objectifs", to: "auto-email-report-gss-obj" },
  { id: "generale", name: "generale", title: "Général", label: "Général", path: "generale", to: "auto-email-report-gss-generale" },
  { id: "generale_n1", name: "generale_n1", title: "Général N-1", label: "Général N-1", path: "generale-n1", to: "auto-email-report-gss-generale-n1" },
  { id: "revenus_supp", name: "revenus_supp", title: "Revenus Supp.", label: "Revenus Supp.", path: "revenus-supp", to: "auto-email-report-gss-revenus-supp" },
  { id: "acquisition", name: "acquisition", title: "Acquisition", label: "Acquisition", path: "acquisition", to: "auto-email-report-gss-acquisition" },
  { id: "finance", name: "finance", title: "Finance", label: "Finance", path: "finance", to: "auto-email-report-gss-finance" },
];

export const GSS_DATASETS = gssDatasets;
